/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC as ReactFC } from 'react';

import * as intl from 'react-intl-universal';

import ModulePaths from 'constants/ModulePaths';
import InsLink from 'shared/components/ins-link/InsLink';
import IntlNumberNotation from 'shared/enums/IntlNumberNotation';
import useCurrency from 'shared/hooks/use-currency/UseCurrency';

import LineChart from '../../line-chart/LineChart';
import CumulativeSavingsProps from './CumulativeSavingsProps';

const CumulativeSavings: ReactFC<CumulativeSavingsProps> = (props) => {
  const { data, meta, filters, xAxisConfig } = props;

  const getCurrencyString = useCurrency();

  /**
   * Formats tick values
   *
   * @param number Tick value
   * @returns {string} Formatted tick value
   */
  const formatNumber = (number): string =>
    getCurrencyString(Number(number), true, IntlNumberNotation.Compact);

  const sliceRenderer = (value): string => getCurrencyString(value, true);

  const legendLabelRenderer = (): string => intl.get('LBL_CUMULATIVE_SAVINGS');

  const renderChartLegend = (): JSX.Element => (
    <div className="chart-legend inline">
      <div className="item">
        <span className="color" style={{ backgroundColor: '#68C7C2' }} />
        <span className="label">
          <span className="name">{intl.get('LBL_CUMULATIVE_SAVINGS')}</span>
        </span>
      </div>
      <div className="item">
        <span className="color" style={{ backgroundColor: '#F8E9C5' }} />
        <span className="label">
          <span className="name">{`${intl.get(
            'LBL_CUMULATIVE_SAVINGS'
          )} ${String(filters.timeUnit.label)}`}</span>
        </span>
      </div>
    </div>
  );

  return (
    <>
      <LineChart
        data={data}
        meta={meta}
        xAxisConfig={xAxisConfig}
        filters={filters}
        tickFormatter={formatNumber}
        sliceRenderer={sliceRenderer}
        legendLabelRenderer={legendLabelRenderer}
      />
      <div className="chart-footer">
        {renderChartLegend()}
        <span className="chart-overview">
          <InsLink
            disabledClass="disabled"
            to={ModulePaths.FinancesPath}
            className="btn btn-secondary btn-sm"
          >
            <i className="icon-arrow-right" /> {intl.get('BTN_FINANCES_PAGE')}
          </InsLink>
        </span>
      </div>
    </>
  );
};

export default CumulativeSavings;
